// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 4H17.5V20H20V22H13V20H15.5V4H13V2H20V4ZM13.5 18H0V6H13.5V18ZM24 18H19.5V6H24V18ZM4 13H10V11H4V13Z"}}]};

const RenameFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'rename-filled',
    ref,
    icon: element,
  },
));

RenameFilledIcon.displayName = 'RenameFilledIcon';

export default RenameFilledIcon;
